import { render, staticRenderFns } from "./CharacterCard.vue?vue&type=template&id=60f50cfa&scoped=true&"
import script from "./CharacterCard.vue?vue&type=script&lang=js&"
export * from "./CharacterCard.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCard.vue?vue&type=style&index=0&id=60f50cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f50cfa",
  null
  
)

export default component.exports